import { defineComponent as _defineComponent } from 'vue'
import { ref, computed } from "vue";
  import {
    Floorplan,
    HouseDesignInterface,
  } from "@/types/HouseDesignInterface";
  import { UserQuoteSelectionInterface } from "@/types/UserQuoteSelectionInterface";
  import { CustomizeHouseStepsEnum } from "@/enums/CustomizeHouseSteps";
  import { BuilderStepsIds } from "@/enums/BuilderStepsIds";
  import BuilderSliderButtons from "@/components/builder/BuilderSliderButtons.vue";
  import HouseFeatures from "@/components/builder/HouseFeatures.vue";
  import BuilderLightboxImages from "@/components/builder/BuilderLightboxImages.vue";
  import store from "@/store";
  import { useIsDesktop } from "@/features/useIsDesktop";
  import { formatPrice as formatMeters } from "@/helpers/transformation/price";
  import { scrollToNextStep } from "@/helpers/builder/scrollToNextStep";
  import BuilderEstimatorFloorplansMobile from "./BuilderEstimatorFloorplansMobile.vue";
  interface Props {
    houseDesign: HouseDesignInterface;
    isFeaturesHidden?: boolean;
  }
  
export default /*@__PURE__*/_defineComponent({
  __name: 'BuilderEstimatorFloorplans',
  props: {
    houseDesign: {},
    isFeaturesHidden: { type: Boolean }
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

  const props = __props;

  const { isDesktop } = useIsDesktop(990);

  const showFloorplan = ref<boolean>(false);
  const fadeInEffectSlider = ref<boolean>(false);
  const zoom = ref<number>(1);
  const isImageModalOpen = ref<boolean>(false);

  const selectedHouseDesign = computed(() => props.houseDesign);

  const onButtonClickSlider = () => {
    fadeInEffectSlider.value = !fadeInEffectSlider.value;
  };

  const openImageModal = () => {
    isImageModalOpen.value = true;
  };

  const closeImageModal = () => {
    isImageModalOpen.value = false;
    zoom.value = 1;
  };

  const updateZoom = (value: number) => {
    const newZoom = zoom.value + value;

    if (newZoom >= 1 && newZoom <= 2.6) {
      zoom.value = newZoom;
    }
  };

const __returned__ = { props, isDesktop, showFloorplan, fadeInEffectSlider, zoom, isImageModalOpen, selectedHouseDesign, onButtonClickSlider, openImageModal, closeImageModal, updateZoom, ref, computed, get Floorplan() { return Floorplan }, get HouseDesignInterface() { return HouseDesignInterface }, get UserQuoteSelectionInterface() { return UserQuoteSelectionInterface }, get CustomizeHouseStepsEnum() { return CustomizeHouseStepsEnum }, get BuilderStepsIds() { return BuilderStepsIds }, BuilderSliderButtons, HouseFeatures, BuilderLightboxImages, get store() { return store }, get useIsDesktop() { return useIsDesktop }, get formatMeters() { return formatMeters }, get scrollToNextStep() { return scrollToNextStep }, BuilderEstimatorFloorplansMobile }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})